import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import type { LinkData } from '@core/tellent-assistant-types';
import { IconContainerComponent } from '@core/user-interface-legacy';

import { ListCardComponent } from '../../list-card/list-card.component';

@Component({
  selector: 'rt-list-item-link',
  imports: [ListCardComponent, IconContainerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './list-item-link.component.html',
  styleUrl: './list-item-link.component.less',
})
export class ListItemLinkComponent {
  public readonly data = input.required<LinkData>();
}
